import { toZonedTime } from "date-fns-tz";
export function parseDate(value) {
    try {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var isUtc = typeof value === 'string' ? value.includes('Z') || /^(\d{4})-(\d{2})-(\d{2})/.test(value) : false;
        var finalDate = isUtc ? toZonedTime(value, timezone) : new Date(value);
        if (isNaN(finalDate.valueOf()) || typeof value === 'string' && !value.includes(finalDate.getFullYear().toString())) {
            return value;
        }
        return finalDate;
    } catch (e) {
        return value;
    }
}

//# sourceMappingURL=parseDate.js.map